var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnounce = function SvgAnnounce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 13,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2E2F3C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.024.327a1.215 1.215 0 0 1 1.553 1.169l-.016 10.166a1.215 1.215 0 0 1-1.556 1.164l-5.786-1.785v.61a1.215 1.215 0 0 1-1.217 1.213l-2.26-.004a1.215 1.215 0 0 1-1.212-1.216l.003-2.049-1.954-.602a1.215 1.215 0 0 1-.867-1.166l.004-2.542a1.215 1.215 0 0 1 .87-1.164l5.804-1.77.004-.001L14.015.33zM8.231 3.453l6.046-1.844-.015 9.936-6.04-1.864zM6.92 10.64l-.001.924-2.09-.004.003-1.564zM4.399 8.502l2.523.779.009-5.43L2.015 5.35l-.003 2.416 2.34.722zM24.087 3.562a.65.65 0 0 1-.137.771l-1.373 1.275.82 1.233a.65.65 0 0 1-.416.997l-4.79.945a.65.65 0 0 1-.568-1.114l1.373-1.275-.82-1.232a.65.65 0 0 1 .416-.998l4.79-.945a.65.65 0 0 1 .705.343m-4.29 1.69.588.883a.65.65 0 0 1-.1.836l-.1.094 1.59-.314-.587-.883a.65.65 0 0 1 .099-.836l.101-.095z"
  }))));
};
export default SvgAnnounce;